import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const MOBILE_BREAKPOINT = "md";
const Wrapper = styled(Box)`
    display: grid;
    grid-template-columns: max-content 1fr auto;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-template-areas: 'name content addon';
    padding: ${spacing("xxl")} 0;
`;
const Name = styled(Box)`
    grid-area: name;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: ${spacing("xxl")};
    padding: ${spacing("lg")} 0;
`;
const Content = styled(Box)`
    grid-area: content;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    ${({ theme }) => theme.breakpoint("md")`
        place-content: flex-end;
    `}
`;
const Nav = styled(Box)``;
const Addon = styled(Box)`
    grid-area: addon;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: ${spacing("xl")};
`;
const Styled = {
  Wrapper,
  Name,
  Content,
  Nav,
  Addon
};

export { MOBILE_BREAKPOINT, Styled };
//# sourceMappingURL=styled.es.js.map
